import React from 'react';
import { JumpingLoader } from '~/UIKit';
import { OnboardingHeader } from '../';
import { makeStyles } from '~/UIKit/Style';
import { useOnboardingConfirmation } from './useOnboardingConfirmation';
import { OnboardingConfirmationFailed, OnboardingConfirmationSuccess } from './';
import { FONT_SIZE_SMALLISH } from '~/Constants/UI.constants';

const useStyles = makeStyles((theme) => ({
  onboardingConfirmationContainer: {
    display: 'flex',
    flexDirection: 'row',
    position: 'relative',
    fontWeight: 300,
    fontSize: FONT_SIZE_SMALLISH,
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column-reverse',
    },
  },
  onboardingConfirmationContent: {
    textAlign: 'center',
    maxWidth: 552,
    margin: 'auto',
    padding: '0 20px',
  },
}));

export const OnboardingConfirmation = () => {
  const { classes } = useStyles();
  const { onRedirectToDashboard, confirmationSuccess, isLoading } = useOnboardingConfirmation();

  const renderResult = () => (
    <>
      <OnboardingHeader withLogo />
      <div className={classes.onboardingConfirmationContainer}>
        {confirmationSuccess ? (
          <OnboardingConfirmationSuccess onStartClick={onRedirectToDashboard} />
        ) : (
          <OnboardingConfirmationFailed />
        )}
      </div>
    </>
  );

  return isLoading ? <JumpingLoader /> : renderResult();
};

export default OnboardingConfirmation;
